import {LocaleType} from '../enum/LocaleType'

export function resolveLocaleType(value: unknown): LocaleType {
  if(typeof value === 'string' && Object.values(LocaleType).includes(value as LocaleType)) {
    return value as LocaleType
  }
  return LocaleType.English
}
